import { render, staticRenderFns } from "./AddSkillPage.vue?vue&type=template&id=04484004&"
import script from "./AddSkillPage.vue?vue&type=script&lang=js&"
export * from "./AddSkillPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports